import { render, staticRenderFns } from "./WorkflowTextArea.vue?vue&type=template&id=87558266&"
import script from "./WorkflowTextArea.vue?vue&type=script&lang=ts&"
export * from "./WorkflowTextArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports